"use strict";

const fitInside = (width, height, max) => {
    const scale = Math.min(max / width, max / height, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
};

const canvasToDataUrl = (source, width, height, max) => new Promise((resolve, reject) => {
    const size = fitInside(width, height, max);
    const canvas = document.createElement("canvas");
    canvas.width = size.width;
    canvas.height = size.height;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(source, 0, 0, size.width, size.height);
    let hasAlpha = false;
    try {
        const pixels = ctx.getImageData(0, 0, size.width, size.height).data;
        for (let i = 3; i < pixels.length; i += 4) {
            if (pixels[i] < 255) {
                hasAlpha = true;
                break;
            }
        }
    } catch (e) {
        hasAlpha = false;
    }
    canvas.toBlob((blob) => {
        if (!blob) {
            reject(new Error("blob"));
            return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error || new Error("read"));
        reader.readAsDataURL(blob);
    }, hasAlpha ? "image/png" : "image/jpeg", hasAlpha ? undefined : 0.75);
});

const loadImageElement = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
        URL.revokeObjectURL(url);
        resolve({
            source: img,
            width: img.naturalWidth,
            height: img.naturalHeight,
            cleanup: () => {},
        });
    };
    img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("image"));
    };
    img.src = url;
});

const loadImageSource = (file) => {
    if (typeof createImageBitmap !== "function") {
        return loadImageElement(file);
    }
    try {
        return createImageBitmap(file, { imageOrientation: "from-image" }).then((bitmap) => ({
            source: bitmap,
            width: bitmap.width,
            height: bitmap.height,
            cleanup: () => {
                if (bitmap.close) bitmap.close();
            },
        })).catch(() => loadImageElement(file));
    } catch (e) {
        return loadImageElement(file);
    }
};

const compressImage = (file, max) => loadImageSource(file).then((loaded) => {
    return canvasToDataUrl(loaded.source, loaded.width, loaded.height, max).then((dataUrl) => {
        loaded.cleanup();
        return dataUrl;
    }, (err) => {
        loaded.cleanup();
        throw err;
    });
});

var configCtrl = ["$translate", "toast", "Upload", "myTenant", "BuilderDataService", "$timeout", "$uibModal", function ($translate, toast, Upload, myTenant, BuilderDataService, $timeout, $uibModal) {
    var _this = this;
    this.elementsList = require("./dashboardBuilderElements")($translate);
    if (_this.element.templateData==undefined || _this.element.templateData.width==undefined)
      _this.element.templateData = { ..._this.element.templateData, width:"100%" }
    if(!_this.element.templateData.expandableForm && !_this.element.templateData.showInline){
      _this.element.templateData.showModal = true;
    }
    if(_this.element.templateData.pageSize == undefined) _this.element.templateData.pageSize = 30;

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })
    // this.voolksTenantId = "56fc21e402a3885f336d8d3f";
    // this.pampaTenantId = "60b0d8d8015d5f6b39cdbd57";
    // this.pampaEPTenantId = "5f159630815b7f852fbd1f6a";

    this.canBeTitle = function (type) {
      let esquemaItem = this.elementsList.find((e) => e.type == type);
      if (esquemaItem && esquemaItem.templateData) {
        if ("useAsTitle" in esquemaItem.templateData) {
          return true;
        }
      }
      return false;
    };

    this.showAdvanced = function () {
      var isSimpleListChild = false;
      _this.form.pages.forEach(function (page) {
        page.fields
          .filter(function (field) {
            return field.type === "simplelist";
          })
          .forEach(function (list) {
            if (isSimpleListChild) {
              return;
            }
            isSimpleListChild = list.nodes.reduce(function (value, node) {
              if (node.id === _this.element.id) {
                value = true;
              }
              return false;
            }, false);
          });
      });

      if (isSimpleListChild) {
        return false;
      }
      return true;
    };

    this.getElements = function (form, type, eleId = undefined, isForValidator = false) {
        // console.log("llamado", eleId, type);
        const walk = (arrFields, type, eleId) => {
            return arrFields.reduce((ret, field) => {
                ret.hasEleId = ret.hasEleId || (field.id == eleId);
                if (field.type == type) ret.fields.push({ ...field, name: (field.name || field.label).concat(" (", field.id, ")") });
                if (Array.isArray(field.nodes)) {
                    let ret2 = walk(field.nodes, type, eleId);
                    ret.hasEleId = ret.hasEleId || ret2.hasEleId;
                    ret.fields = ret.fields.concat(field.type == "simplelist" && !ret2.hasEleId ? [] : ret2.fields);
                }
                return ret;
            }, { hasEleId: false, fields: [] })

        }
        let lstFields = [];
        form.pages.forEach(page => {
            lstFields = lstFields.concat(walk(page.fields, type, eleId).fields);
        });
        if (isForValidator) {
            form.validate_pages?.forEach(page => {
                lstFields = lstFields.concat(walk(page.fields, type, eleId).fields);
            });
        }
        return [
            {
                name: "",
                type,
            },
        ].concat(lstFields);
    };

  /*   this.elementsSelect = this.getElements(this.form, 'select', this.element.id);
    this.elementsCheckbox = this.getElements(this.form, 'checkbox', this.element.id);
 */
    const uploadSeq = { logo: 0, image: 0 };

    this.uploadFiles = (file, errFile, destino) => {
      const invalid = Array.isArray(errFile) ? errFile[0] : errFile;
      if (!file) {
        if (invalid) {
          toast.error($translate.instant("DASHBOARD.DASH_BUILDER.CONFIG_DIR.IMAGE_PROCESS_ERROR"));
        }
        return;
      }
      const max = destino === "logo" ? 80 : 800;
      const seq = ++uploadSeq[destino];
      compressImage(file, max).then((dataUrl) => {
        if (seq !== uploadSeq[destino]) return;
        $timeout(() => {
          _this.element.templateData[destino] = dataUrl;
        });
      }).catch(() => {
        if (seq !== uploadSeq[destino]) return;
        $timeout(() => {
          toast.error($translate.instant("DASHBOARD.DASH_BUILDER.CONFIG_DIR.IMAGE_PROCESS_ERROR"));
        });
      });
    };

    this.openImagePreview = (src, titleKey, frameSize, stretch) => {
      if (!src) return;
      $uibModal.open({
        animation: true,
        templateUrl: "dashboard-builder/showcaseImageModal.html",
        controller: ["$uibModalInstance", "imageSrc", "titleKey", "frameSize", "stretch", function ($uibModalInstance, imageSrc, titleKey, frameSize, stretch) {
          this.imageSrc = imageSrc;
          this.titleKey = titleKey;
          this.frameSize = frameSize;
          this.stretch = stretch;
          this.close = () => $uibModalInstance.dismiss();
        }],
        controllerAs: "ctrl",
        windowClass: "dialog showcase-image-preview",
        resolve: {
          imageSrc: () => src,
          titleKey: () => titleKey,
          frameSize: () => frameSize,
          stretch: () => !!stretch,
        },
      });
    };

    //temporal function to handle requires...
    this.setRequiredElement = function () {
      let requirements = [
        { field: _this.selectedSelect, value: _this.selectedOption },
        { field: _this.selectedCheckbox, value: true },
      ];
      this.element.requires = [];
      requirements.forEach((element) => {
        if (!element.field || element.field.name=="") {
          return;
        }
        this.element.requires.push({
          elementId: element.field.id,
          type: element.field.type,
          expectedValue: element.value,
        });
      });
    };

    this.preloadItems = () => {
        if(_this.element.templateData.preloaded == false) {
            _this.element.templateData.options = [];
            _this.element.templateData.dynamicOptions = undefined;
            _this.element.isDinamic = false;
        }
    }

    //hack to use requires before building the whole system....

    //para retrocompatibilidad
    if (
      this.element.type == "date" &&
      this.element.validation?.maxFuture == undefined
    )
      this.element.validation.maxFuture = 0;

    if (
      this.element.type == "date" &&
      this.element.validation?.maxPrevious == undefined
    ) {
      this.element.validation.allowPrevious = this.element.templateData
        .allow_old_dates
        ? true
        : false;
      this.element.validation.maxPrevious = 0;
      this.element.templateData.allow_old_dates = undefined;
    }
    if (
      this.element.type == "time" &&
      this.element.validation?.maxPrevious == undefined
    ) {
      this.element.validation.allowPrevious = this.element.templateData
        .allow_old_times
        ? true
        : false;
      this.element.validation.maxPrevious = 0;
      this.element.templateData.allow_old_times = undefined;
    }
    
    // Geo Precision NEW
    if (this.element.type == "geo") {
        // The highPrecision field was not initialized when it was false. Therefore, it might not have been defined on the object.
        if (!this.element.highPrecision) {
            this.element.highPrecision = '1000';
        } else if (this.element.highPrecision == true) {
            this.element.highPrecision = '15';
        }
    }

    this.getFlattenedInputElements = function (form, isForValidator = false) {
        const processPages = function(pages, formType) {
            let flattenedElements = [];
    
            pages?.forEach((page, pageIndex) => {
                const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType);
                flattenedElements = flattenedElements.concat(elementsWithLevels);
            });
            return flattenedElements;
        };
        let flattenedPages = [];
        let flattenedValidatePages = [];
        flattenedPages = processPages(form.pages, "Formulario");
        if (isForValidator) {
            flattenedValidatePages = processPages(form.validate_pages, "Validador");
        }
        return flattenedPages.concat(flattenedValidatePages)
    };
    this.getElementsWithLevels = function (fields, pageIndex, level, formType) {
        return fields?.flatMap(function (field) {
            const isElementInSimpleList = function(nodes) {
                return nodes.some(node => {
                    if (node.id === _this.element.id) {
                        return true;
                    }
                    if (node.nodes && node.nodes.length > 0) {
                        return isElementInSimpleList(node.nodes);
                    }
                    return false;
                });
            };

            if (field.type === 'simplelist') {
                const elementInCurrentSimpleList = field.id === _this.element.id || isElementInSimpleList(field.nodes || []);

                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: `Página ${pageIndex + 1}`
                };
                const nodesProcessed = elementInCurrentSimpleList
                    ? _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType)
                    : [];

                return [currentField].concat(nodesProcessed);
            }

            if (field.type === 'group') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: `Página ${pageIndex + 1}`
                };
                // Procesar los nodos dentro de 'group' despues de 'group'
                const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                return [currentField].concat(nodesProcessed);
            }
            return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
        });
    };
    
    this.form = BuilderDataService.getForm();
    this.inputElementsForForm = this.getFlattenedInputElements(this.form, this.isForValidator);

  // Restaurar selectedCheckbox y selectedSelect después de inicializar this.form
  if (this.element.requires) {
    this.element.requires.forEach((req) => {
      if (req.type == "boolean")
        //para retrocompatiblidad
        req.type = "checkbox";
      let item;
      if (_this.isForValidator) {
        let elements = this.getFlattenedInputElements(this.form, this.isForValidator);

        item = elements?.find((ele) => {
          let found = ele.id == req.elementId;
          return found;
        })
      } else {
        // Para checkbox, buscar solo dentro del grupo actual
        if (req.type == "checkbox" && this.element.type == "group") {
          item = _this.getElements(_this.form, req.type, this.element.id, this.isForValidator).find((ele) => ele.id == req.elementId);
        } else if (req.type == "select") {
          // Para select, buscar en inputElementsForForm
          item = _this.inputElementsForForm?.find((ele) => ele.id == req.elementId && ele.type == "select");
        } else {
          // Para otros tipos, buscar en todo el formulario
          item = _this.getElements(_this.form, req.type, undefined, this.isForValidator).find((ele) => ele.id == req.elementId);
        }
      }
      if (item) {
        if (item.type == "checkbox") {
          _this.selectedCheckbox = item;
        } else if (item.type == "select") {
          _this.selectedSelect = item;
          _this.selectedOption = req.expectedValue;
        }
      }
    });
  }
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      element: "=",
      open: "=",
      form: "=",
      reportConfig: '=',
      isForValidator: "=",
    },
    replace: true,
    controller: configCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "dashboard-builder/configDirective.html",
  };
};
